import React, {useEffect, useState } from 'react';
import { Text, View, Image, StyleSheet, SafeAreaView, TouchableOpacity, ActivityIndicator, Platform} from 'react-native';
import GSS from '../GlobalStyleSheet2';
import { useEnv, useSystemInfo } from '../AppContext';
import ProgressButton from '../ProgressButton';
import SimpleIcon from '../../assets/80px-Interactive_icon.png'
import PhoneIcon from '../../assets/booking.png'
import { WebView } from 'react-native-webview';
import { routerServer, SaveToSystem, LoadFromSystem } from '../Global';
import { SaveCertiIDToDB } from '../api';
import { useModal } from '../ModalContext';
import TopHeader from '../CloseHeader';
import { useLoginProc } from '../LoginProc2';
import { useItemContext } from '../ItemContext';
import { useInitProc } from '../InitProc';

const OK_SERVER = 'https://myshott.kr';

function CertifyID ({navigation, route}) {
    const { ENV } = useEnv();
    const [isProc, setIsProc] = useState(false);
    const [webUrl, setWebUrl] = useState('');
    const [certiCompleted, setCertiCompleted] = useState(false);
    const [ userName, setUserName] = useState();
    const [ userPhone, setUserPhone] = useState();
    const [ userBirth, setUserBirth] = useState();
    const { showModalMessage } = useModal();
    const [targetAfterRegister, setTargetAfterRegister] =  useState(route.params?.targetAfterRegister);
    const { loginProc } = useLoginProc();
    const { setSystemInfo }= useSystemInfo();
    const { setItem} = useItemContext();
    const { initProc} = useInitProc();

    async function NextStep()
    {
        //console.log(targetAfterRegister);
        if( targetAfterRegister ) {
            navigation.replace(targetAfterRegister);
        } else {
            navigation.goBack();
        }
    }   
   
    // useEffect(() => {
    //     (async () => {
    //         try {
    //             const ret = checkAgeOver19('20041220');
    //             console.log(ret);
    //         } catch (e) {
    //             console.error(e);
    //         }
    //     })();        
    // }, []);     

    const NextButton = () => {
        return (
          <ProgressButton
            title={'인증 완료'}
            onPress={NextStep}
            disabled = {certiCompleted ? false : true}
          />
        );
    }  

    function checkAgeOver19(birthDateString) {
        // 생년월일을 Date 객체로 변환
        //const birthDate = new Date(birthDateString);
        const birthYear = parseInt(birthDateString.slice(0,4), 10);
        const birthMonth = parseInt(birthDateString.slice(4,6), 10);
        const birthDay = parseInt(birthDateString.slice(6,8), 10);
        //console.log(birthYear, birthMonth, birthDay);
      
        // 현재 날짜 가져오기
        const currentDate = new Date();
      
        // 만 나이 계산
        let age = currentDate.getFullYear() - birthYear;
        const m = currentDate.getMonth() + 1 - birthMonth;
      
        // 현재 월이 생월보다 작거나, 같은 월이지만 현재 일이 생일보다 작은 경우, 나이에서 1을 뺌
        if (m < 0 || (m === 0 && currentDate.getDate() < birthDay)) {
          age--;
        }
      
        // 만 19세 이상 여부 반환
        return age >= 19;
    }    

    async function SaveCertiID(ok_data, user_id=null) {
        try {
            if ( !checkAgeOver19(ok_data.age) ) {
                const _message = {
                    body : '마이샷은 만19세 이상 서비스 가능 합니다.'
                }
                showModalMessage(_message);
                return;
            }
            if( user_id === null) {
                user_id = ENV.user_id;
            }
    
            let inviter_code = null;
            if( Platform.OS === 'web') {
                inviter_code = localStorage.getItem('inviter_code');
                //console.log(inviter_code);
            }
            //console.log(ok_data);
            const ret = await SaveCertiIDToDB(ok_data, user_id, inviter_code);
            if( ret.success ) {
                setUserName(ok_data.user_name);
                setUserPhone(ok_data.phone_number);
                setUserBirth(ok_data.age);
                setCertiCompleted(true);
            } else {
                const _message = {
                    body : '인증결과를 저장하는데 오류가 발생했습니다. 관리자에게 문의 해 주세요'
                }
                showModalMessage(_message);
            }
        } catch (e) {
            console.log(e);
        }
    }
    
    if( Platform.OS !== 'web') {
        onMessage = (event) => {
            const uri = event.nativeEvent.url;
            //console.log(uri);
            if(uri.startsWith(OK_SERVER))
            {
                setIsProc(false);
                // 서버로부터의 응답 데이터 처리
                const ok_data = JSON.parse(event.nativeEvent.data);
                //console.log(ok_data);
                if( ok_data.ok_type ) 
                {
                    SaveCertiID(ok_data);
                } else {
                    // 인증 오류
                    const _message = {
                        body : '본인인증에 오류가 발생했습니다. 다시 시도해 주세요'
                    }
                    showModalMessage(_message);
                }
            }        
        }   
    }
    
    function check_eziok() {
        setIsProc(true);
        let target;
        if(routerServer === 'http://my.chyh.kr') {
            target = 'eziok2';
        } else {
            target = 'eziok';
        }
        if( Platform.OS === 'web') {
            const app_type = 'web';
            const url = `${OK_SERVER}/${target}/call_std/${app_type}`;
            window.location.href = url;       
        } else {
            const app_type = 'app';
            const url = `${OK_SERVER}/${target}/call_std/${app_type}`;
            targetUrl = url;
            //console.log(url);
            setWebUrl(url);
        }
    }

    function check_mok() {
        setIsProc(true);

        let target;
        if(routerServer === 'http://my.chyh.kr') {
            target = 'mok2';
        } else {
            target = 'mok';
        }
        if( Platform.OS === 'web') {
            const app_type = 'web';
            const url = `${OK_SERVER}/${target}/call_std/${app_type}`;
            window.location.href = url;       
        } else {
            const app_type = 'app';
            const url = `${OK_SERVER}${target}/call_std/${app_type}`;
            setWebUrl(url);
        }
    }

    const CloseButton = () => {
        navigation.goBack();
    };  

    ///////////////////////////////
    let ok_info = route.params?.ok_info ?? null;
    const saveData = route.params?.saveData;

    if(Platform.OS === 'web') {
        useEffect(() => {
            // async 함수를 정의하고 즉시 호출합니다.
            (async () => {
                try {
                    let user_id;
                    let target_after_login;
                    if(ok_info) {
                        const newENV = await initProc();
                        await loginProc(newENV);
                        user_id = newENV.user_id;
                        target_after_login = newENV.target_after_login;         
                    } else {
                        user_id = ENV.user_id;
                        target_after_login = ENV.target_after_login;
                    }
                    if(targetAfterRegister) {
                        target_after_login = targetAfterRegister;
                    }

                    if(ok_info) {
                        //const tmpDataString = localStorage.getItem('tmp_data');
                        // const loadData = JSON.parse(tmpDataString);
                        // if( loadData ) {
                        //     //console.log(loadData);
                        //     setItem(loadData.Item);
                        //     setSystemInfo(loadData.systemInfo);
                        // }
                        //setTargetAfterRegister(tmpDataString);
    
                        //console.log(card_info);
                        // URL 디코딩
                        const decodedJson = decodeURIComponent(ok_info);
                        const ok_data = JSON.parse(decodedJson);
                        if( ok_data?.ok_type ) 
                        {
                            SaveCertiID(ok_data, user_id);
                        } else {
                            // 인증 오류
                            const _message = {
                                body : '본인인증에 오류가 발생했습니다. 다시 시도해 주세요'
                            }
                            showModalMessage(_message);
                        }                        
                    } else {
                        if(user_id) {
                            const newENV = { ... ENV};
                            newENV.target_after_login = targetAfterRegister;
                            await SaveToSystem(newENV);
                            if( saveData ) {
                                const sysDataString = JSON.stringify(saveData);
                                localStorage.setItem('tmp_data', sysDataString);
                            }
    
                            // const url = `${OK_SERVER}/eziok/call_std/1`;
                            // window.location.href = url;                  
                        } else {
                            const _message = {
                            body : '로그인을 다시 시도하고 진행해주세요'
                            }
                            showModalMessage(_message);   
                            navigation.reset({
                                index: 0,
                                routes: [
                                    { 
                                        name: 'MyInfoHome',
                                    },
                                ],
                            });              
                        }                       
                    }
                } catch (e) {
                    // 오류를 적절하게 핸들링합니다. (예: 로깅, 사용자에게 메시지 표시 등)
                    console.error(e);
                }
            })();
        }, [ok_info])      
        //////////////////////////////
    }

    if( isProc === false) {
        return (
            <View style={GSS.mainContainer}>
                <View style={[GSS.emptyViewBox, {flexDirection:'row', justifyContent:'space-between'}]}>
                    <View>
                        <Text style={GSS.mainTitleText}>본인 인증</Text>
                    </View>
                    <TopHeader
                        closeAction={CloseButton}
                    />
                </View>
                <View style={[GSS.mainViewBox, {flex:1}]}>
                    <View style={{flexDirection:'row', alignItems:'center',justifyContent:'center', height:65}}>
                        <TouchableOpacity onPress={() => check_eziok()}>
                            <View style={SS.selectMain}>
                                <Image
                                    source={SimpleIcon}
                                    style={{width:30, height:30}}
                                    resizeMode="contain"
                                />
                                <Text style={GSS.mainInfoTextB}>간편인증</Text>
                            </View>                            
                        </TouchableOpacity>
                        <View style= {{width:10}}/>
                        <TouchableOpacity onPress={() => check_mok()}>
                            <View style={SS.selectMain}>
                                <Image
                                    source={PhoneIcon}
                                    style={{width:30, height:30}}
                                    resizeMode="contain"
                                />
                                <Text style={GSS.mainInfoTextB}>휴대전화 인증</Text>
                            </View> 
                        </TouchableOpacity>
                    </View>
                    <View style={{flex:1}}>
                        <View style={{marginBottom:3}}>
                            <Text style={[GSS.textEmphasis, {color:'#7d9ff8'}]}>
                            간편인증 또는 휴대전화 인증 시 해당 정보(생년월일, 성명, 휴대전화 번호)는 자동으로 입력 됩니다.
                            </Text>
                        </View>
                        {/* <View>
                            <Text style={[GSS.textEmphasis, {color:'#7d9ff8'}]}>
                            본인인증 시 제공되는 정보는 해당 인증기관에서 직접 수집하며, 인증 이외의 용도로 이용 또는 저장되지 않습니다.
                            </Text>
                        </View>  */}
                        <View style= {{height:5}}/>
                        <View style={{margin:5, marginBottom:5}}>
                            <Text style={GSS.mainDefaultTextB}>생년월일 <Text style={GSS.emphasisText}>*</Text></Text>
                            <View style={SS.textMain}>
                                <Text style={{fontSize:16, color:'#cccccc', marginLeft:10}}>
                                    { userBirth ? userBirth : '생년월일 8자리(19810101)'}
                                </Text>
                            </View>
                        </View>
                        <View style={{margin:5, marginBottom:5}}>
                            <Text style={GSS.mainDefaultTextB}>성명 <Text style={GSS.emphasisText}>*</Text></Text>
                            <View style={SS.textMain}>
                                <Text style={{fontSize:16, color:'#cccccc', marginLeft:10}}>
                                    { userName ? userName : '홍길동'}
                                </Text>
                            </View>
                        </View>
                        <View style={{margin:5, marginBottom:5}}>
                            <Text style={GSS.mainDefaultTextB}>휴대전화 번호 <Text style={GSS.emphasisText}>*</Text></Text>
                            <View style={SS.textMain}>
                                <Text style={{fontSize:16, color:'#cccccc', marginLeft:10}}>
                                    { userPhone ? userPhone : '010-1234-5678'}
                                </Text>
                            </View>
                        </View>                                   
                    </View>
                </View>
                <View style={[GSS.mainViewBox, {margin: 5, alignItems:'center', justifyContent:'center'}]}>
                  <NextButton/>
                </View>   
            </View>    
        );
    } else {
        if( Platform.OS === 'web') {
            return (
                <View style={GSS.mainContainer}>
                    <View style={{alignItems: 'center', justifyContent:'center'}}>
                        <Text style={GSS.mainDefaultText}>...</Text>
                        <View style={GSS.activityIndicatorContainer}>
                            <ActivityIndicator size='large' color="#0000ff" />
                        </View>                    
                    </View>       
              </View>
            ); 
        } else {
            return (
                <SafeAreaView style={GSS.droidSafeArea}>
                    <WebView 
                        originWhitelist={['*']}
                        scalesPageToFit={false}
                        //source={{ uri: `${routerServer}/apple/call_apple`, webSecurityEnabled: false }}
                        source = {{ uri: webUrl }}
                        javaScriptEnabled={true}
                        onMessage={onMessage}
                    />
                </SafeAreaView>
            );
        }
    }
};

const SS = StyleSheet.create({
    selectMain: {
        flexDirection:'row', 
        width:150, 
        height:50, 
        borderWidth: 1,
        borderColor: '#dddddd',
        justifyContent:'center', 
        alignItems:'center',
        backgroundColor: '#f5f5f5',
        borderRadius:25
    },
    textMain: {
        height:35,
        borderWidth: 1,
        borderColor: '#dddddd',
        justifyContent:'center', 
        backgroundColor: '#f5f5f5',
        borderRadius:10,
        marginTop:3
    }
  });

export default CertifyID;